export const GOOGLE_API_KEY = "AIzaSyBcUCMUB4RZM697623RdSwNRqPQFVsGZP8"